import React, { FC, useEffect, useState } from 'react';
import { ConfirmationDialog } from '../../shared/components';
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../shared';
import apiRoutes from '../../../config/api/routes';
import { ITrajectoryDetail } from '../../../config/api/models/Trajectory';

type ConfirmationTrajectory = {
  id: string;
  title: string;
};

type PublishUnPublishHandlerProps = {
  trajectory: ITrajectoryDetail;
  publishTrigger: number;
  unPublishTrigger: number;
  onPatchDraft: () => void;
};

export const PublishUnPublishHandler: FC<PublishUnPublishHandlerProps> = ({
  trajectory,
  publishTrigger,
  unPublishTrigger,
  onPatchDraft,
}) => {
  const { t } = useTranslation();
  const [
    confirmationTrajectory,
    setConfirmationTrajectory,
  ] = useState<ConfirmationTrajectory | null>(null);
  const [openConfirmPublishDraft, setOpenConfirmPublishDraft] = useState(false);
  const [openConfirmUnPublishDraft, setOpenConfirmUnPublishDraft] = useState(false);

  const [patchDraftResponse, patchDraft] = useFetch(apiRoutes.toggleTrajectoryDraft(trajectory.id), {
    method: 'PATCH',
  });

  useEffect(() => {
    if (publishTrigger > -1) {
      setConfirmationTrajectory({
        id: trajectory?.id,
        title: !!trajectory.parentId ? trajectory.parentTitle! : trajectory.title,
      });
      setOpenConfirmPublishDraft(true);
    }
  }, [trajectory, publishTrigger]);

  useEffect(() => {
    if (unPublishTrigger > -1) {
      setConfirmationTrajectory({
        id: trajectory.id,
        title: !!trajectory.parentId ? trajectory.parentTitle! : trajectory.title,
      });
      setOpenConfirmUnPublishDraft(true);
    }
  }, [trajectory, unPublishTrigger]);

  useEffect(() => {
    if (!patchDraftResponse.success) return;
    onPatchDraft();
  }, [patchDraftResponse, onPatchDraft]);

  const handleCloseConfirmPublish = (result: boolean) => {
    setOpenConfirmPublishDraft(false);

    if (!confirmationTrajectory || !result) return;

    patchDraft();
    setConfirmationTrajectory(null);
  };

  const handleCloseConfirmUnPublish = (result: boolean) => {
    setOpenConfirmUnPublishDraft(false);

    if (!confirmationTrajectory || !result) return;

    patchDraft();
    setConfirmationTrajectory(null);
  };

  return (
    <>
      {confirmationTrajectory && (
        <>
          <ConfirmationDialog
            open={openConfirmPublishDraft}
            title={t('books.chapter.trajectories.confirmPublish.title')}
            description={t('books.chapter.trajectories.confirmPublish.description').replace(
              '%title%',
              confirmationTrajectory.title
            )}
            onClose={handleCloseConfirmPublish}
          />
          <ConfirmationDialog
            open={openConfirmUnPublishDraft}
            title={t('books.chapter.trajectories.confirmUnPublish.title')}
            description={t('books.chapter.trajectories.confirmUnPublish.description').replace(
              '%title%',
              confirmationTrajectory.title
            )}
            onClose={handleCloseConfirmUnPublish}
          />
        </>
      )}
    </>
  );
};
